import { Component } from 'react'
import LoginSectionLayout from './LoginSectionLayout'
import RegisterSectionLayout from './RegisterSectionLayout'

export default class HomeSectionLayout extends Component {

    render() {
        return (
            <>
                {/* <div className='col-12 '> */}
                {!this.props.isRegister ? <LoginSectionLayout expired={this.props.expired} exists={window.location.toString().includes('exists=true')} /> : <RegisterSectionLayout />}
                {/* </div> */}
                {/* <div className='col-12 col-md-6 p-3'>
                    <RegisterSectionLayout />
                </div> */}
            </>
        )
    }
}
